import type { RunState } from "../types/state";

/**
 * The run's clock as the steps read it: whether this tick is one of a cadence's, and the three
 * intervals most steps key on (production, move, combat). A step that acts on a cadence asks
 * here instead of writing its own `tick % interval` arithmetic.
 */

/** This tick is on a cadence of `ticks`; `offset` 1 is the tick before each one (City Command's duty). */
export function onCadence(state: RunState, ticks: number, offset = 0): boolean {
  return (state.tick + offset) % ticks === 0;
}

/** The production step's tick: income, walls, healing, Will, debts, yards. */
export function isProductionTick(state: RunState): boolean {
  return onCadence(state, state.rules.productionIntervalTicks);
}

/** The move step's tick: units and Kings take their steps. */
export function isMoveTick(state: RunState): boolean {
  return onCadence(state, state.rules.moveIntervalTicks);
}

/** The combat step's tick: blows land, contact breaks, units break. */
export function isCombatTick(state: RunState): boolean {
  return onCadence(state, state.rules.combatIntervalTicks);
}
